<validation-results [validationResults]="validationResults"></validation-results>
<ng-container *ngIf="dataLoaded">
    <h2>{{tableTitle}}</h2>
    <table class="mvd_table--primeng mvd_table--notfixed">
        <thead>
            <tr>
                <th>One Time Mailing</th>
                <th>Source</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let address of oneTimeMailingAddresses;">
                <td>{{address.inCareOf}}&#9;{{address.addressLine1}}&#9;{{address.addressLine2}}&#9;{{address.city}}&#9;{{address.jurisdictionCode}}&#9;{{address.postalZipCode}}</td>
                <td>{{address.businessTransactionItemKeyType}}</td>
            </tr>
            <tr *ngIf="!oneTimeMailingAddresses || oneTimeMailingAddresses.length == 0">
                <td colspan="2">No Address to Display</td>
            </tr>
        </tbody>
    </table>
</ng-container>